import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { selectService } from '../redux/slices/bookingSlice';
import RegistrationStepperHeader from '../components/RegistrationStepperHeader';
import StepperButtons from '../components/StepperButtons';
import Swal from 'sweetalert2';

const ServiceSelection = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { eventDetails, selectedService } = useSelector((state) => state.booking);

  useEffect(() => {
    if (!eventDetails) {
      navigate('/event-info');
    }
  }, [eventDetails, navigate]);

  const handleServiceSelect = (service) => {
    console.log('Clicking service:', service.event_Service_Id);
    console.log('Currently selected:', selectedService?.event_Service_Id);
    
    // Allow deselection by clicking the same service
    if (selectedService?.event_Service_Id === service.event_Service_Id) {
      console.log('Deselecting service');
      dispatch(selectService(null));
    } else {
      console.log('Selecting new service');
      dispatch(selectService(service));
    }
  };

  const handleNext = () => {
    if (!selectedService) {
      Swal.fire({
        title: 'Service Required',
        text: 'Please select a service before continuing',
        icon: 'warning',
        confirmButtonText: 'OK',
        confirmButtonColor: '#3b82f6'
      });
      return;
    }
    
    // Check if add-ons exist
    const optionalServices = eventDetails?.optionalServices || [];
    const timeOptions = eventDetails?.timeOptions || [];
    
    if (optionalServices.length === 0) {
      // No add-ons, check if time slots exist
      if (timeOptions.length === 0) {
        // No add-ons and no time slots, go directly to devotee
        navigate('/devotee');
      } else {
        // No add-ons but time slots exist, go to time-slot
        navigate('/time-slot');
      }
    } else {
      // Add-ons exist, go to addon page
      navigate('/addon');
    }
  };

  const services = eventDetails?.services || [];
  const totalAmount = Number(selectedService?.service_Price || 0);
  
  console.log('ServiceSelection - selectedService:', selectedService);
  console.log('ServiceSelection - services count:', services.length);
  if (services.length > 0) {
    console.log('ServiceSelection - first service:', services[0]);
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-purple-50 to-pink-50 pb-24">
      <div className="container mx-auto px-4 py-8">
        <div className="max-w-5xl mx-auto">
          <div className="overflow-hidden rounded-[28px] bg-white/70 backdrop-blur-xl shadow-[0_26px_70px_-45px_rgba(15,23,42,0.55)] border border-white/60 mb-4">
            <RegistrationStepperHeader
              title={(eventDetails?.event?.event_Name || eventDetails?.Event?.event_Name || 'Event Registration')}
              subtitle={null}
              backPath="/event-info"
              backLabel="Back"
              eventDetails={eventDetails}
            />

            <div className="p-6">
              <div className="rounded-2xl bg-white/85 border border-gray-200/70 shadow-sm">
                <div className="px-5 pt-4 pb-3 border-b border-gray-200/70">
                  <div className="text-sm font-semibold text-gray-900">Pooja / Seva Selection</div>
                  <div className="text-xs text-gray-500">Choose one option.</div>
                </div>

                <div className="p-5">
                  {services.length > 0 ? (
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                      {services.map((service, index) => {
                        const isSelected = selectedService?.event_Service_Id === service.event_Service_Id;
                        return (
                          <div
                            key={service.event_Service_Id || index}
                            onClick={() => handleServiceSelect(service)}
                            className={`relative cursor-pointer rounded-2xl border transition-all overflow-hidden ${
                              isSelected
                                ? 'border-indigo-500 shadow-[0_18px_45px_-28px_rgba(79,70,229,0.55)] bg-gradient-to-b from-indigo-50/60 via-white to-white'
                                : 'border-gray-200 bg-white hover:shadow-md'
                            }`}
                          >
                            <div className="absolute inset-0 pointer-events-none">
                              <div className="absolute -left-10 -top-10 h-28 w-28 rounded-full bg-indigo-500/10 blur-2xl"></div>
                              <div className="absolute right-0 top-0 h-28 w-28 rounded-full bg-amber-400/10 blur-2xl"></div>
                            </div>

                            <div className="relative p-4">
                              <div className="flex items-start justify-between gap-3">
                                <div className="inline-flex h-11 w-11 items-center justify-center rounded-full bg-white shadow-sm border border-gray-200">
                                  <span className="text-lg">🙏</span>
                                </div>

                                <div className="shrink-0 inline-flex items-center rounded-full bg-white px-2.5 py-1 text-[11px] font-semibold text-gray-700 border border-gray-200 shadow-sm">
                                  ${Number(service.service_Price || 0).toFixed(2)}
                                </div>
                              </div>

                              <div className="mt-3">
                                <div className="inline-flex items-center gap-2 rounded-full bg-slate-50 px-3 py-1 text-[11px] font-semibold text-gray-600 border border-gray-200">
                                  <i className="fas fa-om text-[10px]"></i>
                                  Pooja Seva
                                </div>
                              </div>

                              <div className="mt-3 text-sm font-semibold text-gray-900">
                                {service.service_Name}
                              </div>

                              {service.service_Description ? (
                                <div className="mt-1 text-xs text-gray-500 line-clamp-2">
                                  {service.service_Description}
                                </div>
                              ) : null}

                              <div className="mt-4">
                                <div
                                  className={`inline-flex items-center gap-2 rounded-full px-3 py-1 text-[11px] font-semibold border ${
                                    isSelected
                                      ? 'bg-indigo-50 text-indigo-700 border-indigo-200'
                                      : 'bg-white text-gray-500 border-gray-200'
                                  }`}
                                >
                                  {isSelected ? (
                                    <>
                                      <i className="fas fa-check text-[10px]"></i>
                                      Selected
                                    </>
                                  ) : (
                                    <>Tap to select</>
                                  )}
                                </div>
                              </div>
                            </div>

                            <div className="relative h-1.5 bg-slate-100">
                              <div
                                className={`h-full transition-all ${
                                  isSelected
                                    ? 'w-full bg-gradient-to-r from-indigo-600 via-purple-600 to-amber-500'
                                    : 'w-0 bg-transparent'
                                }`}
                              />
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  ) : (
                    <div className="text-center py-12 bg-white rounded-xl shadow-sm border border-gray-200">
                      <i className="fas fa-inbox text-gray-400 text-6xl mb-4"></i>
                      <p className="text-gray-600 text-lg">No services available for this event</p>
                    </div>
                  )}
                </div>

                <div className="px-5 pb-5">
                  <div className="rounded-2xl bg-amber-50/70 border border-amber-100 px-4 py-3 text-xs text-amber-900">
                    Pooja seva that will be provided at Temple
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <StepperButtons
        wrapperClassName="bg-white/90 backdrop-blur-xl"
        containerClassName="px-4 py-3"
        backPath="/event-info"
        onNext={handleNext}
        nextLabel="Next"
        nextDisabled={!selectedService}
        centerContent={
          <div className="text-xs text-gray-500">
            Total:
            <span className="ml-2 text-sm font-semibold text-gray-900">
              ${totalAmount.toFixed(2)}
            </span>
          </div>
        }
      />
    </div>
  );
};

export default ServiceSelection;
